<style type="text/css" media="screen" scoped></style>
<template>
  <div class="small-screen">
    <!--  filter and sort btn   -->
    <div
      class="text-center "
      style="position: fixed; bottom: 10px; width: 100%;z-index: 60"
    >
      <v-row justify="center">
        <v-col cols="7" class="pa-0 ">
          <div
            style="background-color: #FFFFFF;border-radius: 20px ;z-index: 2"
            class="d-flex border-a justify-center"
          >
            <div
              class="pr-3 py-2 border-r text-uppercase text-center cursor-pointer"
              style="width: 50%"
              @click="openDialog(1)"
            >
              {{ $t("SORT") }}
              <v-icon>{{ mdiSort }}</v-icon>
            </div>
            <div
              class="pl-3 py-2 text-center cursor-pointer "
              style="width: 50%"
              @click="openDialog(2)"
            >
              {{ $t("FILTER") }}
              <v-icon>{{ mdiFilterVariant }}</v-icon>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- dialog for filter and sort -->
    <v-dialog v-model="dialog" max-width="375">
      <v-card style="overflow-x:hidden">
        <!--    sort by     -->
        <div v-if="type == 1">
          <p class="dialog-title pt-5 text-center">{{ $t("SORT_BY") }}</p>
          <v-card-text class="text-center">
            <div v-for="item in sort_by_option" :key="item.id">
              <v-btn
                rounded
                outlined
                :color="item == sort_by ? 'primary' : 'rgba(51, 51, 51, 0.7)'"
                width="230px"
                class="font-weight-bold mb-3"
                @click="sort(item)"
              >
                {{ item }}
              </v-btn>
            </div>
          </v-card-text>
          <div class="text-center py-5">
            <v-btn
              rounded
              depressed
              color="white"
              width="180px"
              height="45px"
              class="font-weight-bold mt-3"
              @click="dialog = false"
            >
              {{ $t("CLOSE") }}
            </v-btn>
          </div>
        </div>
        <!--  filter -->
        <div v-if="type == 2">
          <p class="dialog-title pt-5 text-center">
            {{ $t("FILTER_BY_CARD_TYPE") }}
          </p>
          <v-card-text
            class="text-center"
            style="max-height: 400px; overflow-y: scroll"
          >
            <div
              v-for="template_type in template_type_list"
              :key="template_type.id"
            >
              <v-checkbox
                class="mt-0 py-2"
                v-model="id_list"
                :label="template_type.localized_name"
                :value="template_type.id.toString()"
                hide-details
                dense
              ></v-checkbox>
            </div>
          </v-card-text>
          <div class="text-center py-5">
            <v-btn
              rounded
              color="primary"
              width="180px"
              height="45px"
              class="font-weight-bold"
              @click="applyFilter"
            >
              {{ $t("APPLY_FILTER") }}
            </v-btn>
            <br />
            <v-btn
              rounded
              depressed
              color="white"
              width="180px"
              height="45px"
              class="font-weight-bold mt-3"
              @click="dialog = false"
            >
              {{ $t("CLOSE") }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mdiFilterVariant, mdiSort } from "@mdi/js";

export default {
  props: {
    sort_by: {
      type: String
    },
    sort_by_option: {
      type: Array
    },
    template_type_list: {
      type: Array
    },
    template_type_id_list: {
      type: Array
    }
  },
  data() {
    return {
      mdiFilterVariant,
      mdiSort,
      dialog: false,
      id_list: this.template_type_id_list,
      type: 1 // 1 for sort 2 for filter
    };
  },
  mounted() {},
  methods: {
    openDialog(type) {
      this.type = type;
      this.dialog = true;
    },
    applyFilter() {
      this.dialog = false;
      this.$emit("filter", this.id_list);
    },
    sort(value) {
      this.dialog = false;
      this.$emit("sort", value);
    }
  }
};
</script>
